<template lang="pug">
el-container(id="RoleList-container")
  el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(id="RoleList-card")
    el-header(id="RoleList-header" height='40px') {{$t('Role list')}}
        el-tooltip(
        effect="light",
        :content="$t('Add new role')",
        placement="left",
        :transition="uxParam('tooltipTransition')",
        :open-delay="uxParam('tooltipActivationDelay')"
      )
        el-button.el-button--mini.float-right(
          id="RoleList-addRoleButton",
          type='success',
          icon='el-icon-plus',
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')",
          @click="handleAdd()"
        )
    .row.header
      .cell.role.header
        .name {{ $t('Role') }}
      .cell.privileges.header
        .name {{ $t('Privileges #') }}
      .cell.buttons.header {{ $t('') }}
    .row(v-for="role of roles", :key='role.id', :id="'RoleList-listRow' + role.id")
      .cell.role {{ role.name}}
      .cell.privileges {{ role.Privileges.length}}
      .cell.buttons
        el-button-group
          el-button(
            :id="'RoleList-editRole' + role.id + 'Button'",
            type="success",
            @click="handleEdit(role)",
            :title="$t('Edit privilege')",
            size="mini"
          )
            font-awesome-icon.float-right.button(icon="edit")
    RoleEdit(:roleId="editedRoleId", :editDialogVisible="editDialogVisible", @closeEditDialog="handleCloseEditDialog()")
</template>

<script>
import RoleEdit from './RoleEdit'

export default {
  props: ['side'],
  components: { RoleEdit },
  created () {
    this.$store.dispatch('Role/getData')
  },
  data () {
    return {
      checked: [],
      multipleSelection: [],
      editDialogVisible: false,
      editedRoleId: undefined,
      errors: {}
    }
  },
  computed: {
    roles: function () {
      return JSON.parse(JSON.stringify(this.$store.getters['Role/listAll'])).sort((a, b) => a.name.localeCompare(b.name))
    },
    selectedRole: function () {
      return this.$store.getters['Role/getSelectedRole']
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (this.side === 'left') {
        this.$store.dispatch('Role/addRolesSelectedLeft', val)
      }
      if (this.side === 'right') {
        this.$store.dispatch('Role/addRolesSelectedRight', val)
      }
    },
    handleAdd () {
      this.editedRoleId = 0
      this.editDialogVisible = true
    },
    handleEdit (row) {
      this.editedRoleId = row.id
      this.editDialogVisible = true
    },
    handleDelete (row) {
      console.log(row)
    },
    handleCloseEditDialog (result) {
      this.editedRoleId = null
      this.editDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.row {
  display: flex;
  font-size: $--font-size-base;
  padding: 10px 0px;
  &.header {
    color: $--color-text-secondary;
  }
  .cell {
    width: calc((100% - 55px)/2);
    border-bottom: $--border-light;
    // border: 1px dotted pink;
    &.header {
      display: flex;
      align-items: center;
      justify-content: left;
      border-bottom: 2px solid $--color-primary;
      margin-bottom: 15px;
      padding-bottom: 15px;
      .name {
        margin-right: 15px;
      }
      .input {
        max-width: 100px;
      }
    }
    &.buttons {
      text-align: right;
      width: 55px;
    }
    &.client {
      .row-inner {
        color: $--color-text-secondary;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Role/List.vue